import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(app)/store/page.tsx");
